import { render, staticRenderFns } from "./DeliveryCompanyView.vue?vue&type=template&id=92872300&"
import script from "./DeliveryCompanyView.vue?vue&type=script&lang=js&"
export * from "./DeliveryCompanyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports